import React from 'react';
import { Button, Modal, Typography } from 'antd';
import { useIntl } from 'react-intl';

const { Text, Title } = Typography;

interface SessionEndedModalProps {
  open: boolean;
  onClose: () => void;
}

const SessionEndedModal: React.FC<SessionEndedModalProps> = ({
  open,
  onClose,
}) => {
  const { formatMessage: t } = useIntl();

  return (
    <Modal
      centered
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      maskClosable={false}
      width={400}
      style={{ borderRadius: 16 }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 24,
          textAlign: 'center',
        }}
      >
        <Title
          level={4}
          style={{
            marginBottom: 16,
            textAlign: 'center',
            fontWeight: 700,
            color: '#000',
          }}
        >
          {t({ id: 'screens.timeout.sessionEnded.title', defaultMessage: 'Your session has ended' })}
        </Title>

        <Text
          style={{
            color: '#666',
            fontSize: 14,
            marginBottom: 24,
            textAlign: 'center',
            lineHeight: '20px',
          }}
        >
          {t({
            id: 'screens.timeout.sessionEnded.description',
            defaultMessage: 'Log in again to continue',
          })}
        </Text>

        <Button
          block
          style={{
            background: '#fff',
            color: '#000',
            fontWeight: 500,
            height: 44,
            borderRadius: 8,
            border: '1px solid #000',
          }}
          onClick={onClose}
        >
          {t({ id: 'buttons.close', defaultMessage: 'Close' })}
        </Button>
      </div>
    </Modal>
  );
};

export default SessionEndedModal;

